import { useAuth } from '../lib/AuthContext';
import { useAdminPreview } from '../lib/AdminPreviewContext';
import { Eye } from 'lucide-react';

export default function AdminPreviewToggle() {
  const { user } = useAuth();
  const { previewMode, setPreviewMode } = useAdminPreview();

  if (user?.role !== 'admin') return null;

  return (
    <div data-testid="admin-preview-toggle" className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full border border-amber-300/60 bg-amber-50 text-amber-800 text-xs font-semibold tracking-wide">
      <Eye className="w-3.5 h-3.5 shrink-0" />
      <span className="hidden sm:inline">Preview:</span>
      <button
        data-testid="preview-b2c-btn"
        onClick={() => setPreviewMode('b2c')}
        className={`px-2.5 py-1 rounded-full transition-all duration-200 ${previewMode === 'b2c' ? 'bg-amber-700 text-white shadow-sm' : 'hover:bg-amber-200'}`}
      >
        B2C
      </button>
      <button
        data-testid="preview-b2b-btn"
        onClick={() => setPreviewMode('b2b')}
        className={`px-2.5 py-1 rounded-full transition-all duration-200 ${previewMode === 'b2b' ? 'bg-amber-700 text-white shadow-sm' : 'hover:bg-amber-200'}`}
      >
        B2B Pro
      </button>
    </div>
  );
}
